module.exports = __webpack_public_path__ + "static/media/bockav-ikon-c80078.49c3d629.png";